<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">Misc Requests</h1>
      <router-link to="/request/misc/add" class="button is-primary is-small is-uppercase">Add</router-link>
    </div>
    <div class="box" style="margin-top: 12px;">
      <component-search></component-search>
      <component-filters></component-filters>
    </div>
    <misc-table class="is-hidden-mobile"></misc-table>
    <misc-list class="is-hidden-tablet"></misc-list>
    <app-paginate module="misc"></app-paginate>
  </div>
</template>
<script>
import ComponentSearch from "./components/search";
import ComponentFilters from "./components/filters";
import MiscTable from "./components/misc-table";
import MiscList from "./components/misc-list";
export default {
  components: {
    ComponentSearch,
    ComponentFilters,
    MiscTable,
    MiscList
  },
  mounted() {
    let component = this;
    component.$store.commit("misc/page", 1);
    component.$store.commit("misc/limit", 10);
    component.$store.commit("misc/role", "all");
    component.$store.commit("misc/docs", []);
    component.$store.commit("misc/totalDocs", 0);
    component.$store.commit("misc/totalPages", 0);
    component.$store.dispatch("misc/index");
  }
};
</script>
<style lang="scss" scoped>
.is-flex {
  .view-title {
    flex-basis: 0;
    flex-grow: 1;
  }
  .add-button {
    margin-top: 12px;
  }
}
</style>
